import React, { useEffect, useRef, useState } from "react";

import { CometdActions } from "../cometD/cometD-action";
import { useCometdContext } from "../cometD/cometdProvider";
import closeImg from "../images/close-icon.png";
import IframeContainer from "../utils/IframeContainer/IframeContainer";

import ActivityIndicator from "./CommonUtils/ActivityIndicator";
import PopUpMessage from "./CommonUtils/PopUpMessage";
import ConversationPage from "./Conversation/ConversationPage";
import MessageNotification from "./Conversation/MessageNotification";
import HWLog from "./HWLibrary/HWLog";
import HWUser from "./HWLibrary/HWUser";
import InitialForm from "./InitialForm/InitialForm";
import LandingPage from "./LandingPage/LandingPage";
import apiService from "./Services/APIService";
import { requestNotification, saveLoginSessionToParent, sendOnAppClose, sendOnAppOpen } from './Services/HWIframeBridge';
import { s360ConfigService } from "./Services/S360Config";
import StartUp from "./StartUp";

import "react-block-ui/style.css";
import "../assets/styles/style.css";

const PageName = {
  initialForm: "initialForm",
  landingPage: "landingPage",
  conversationPage: "conversationPage",
  offlinePage: "offlinePage",
};

function Simplify360Chat(props) {
  const{isShowLanguageDropdown, setIsShowLanguageDropdown,selectedLanguage, setSelectedLanguage, setCometUser, setCometToken}=props

  const cometd = useCometdContext();
  const isLoggedIn = !!HWUser.isLoggedIn();
  const chatMaximizedTrigger = useRef(false);
  const pendingFormData = useRef(null);
  const [visiblePage, setVisiblePage] = useState(PageName.initialForm);
  const [isAppOpen, setIsAppOpen] = useState(false);
  const [showForm, setShowForm] = useState(s360ConfigService?.config?.configDetails?.showForm);
  const [popUpMessage, setPopUpMessage] = useState(null);
  const [showActivityIndicator, setShowActivityIndicator] = useState(false);
  const [isVisible, setIsVisible] = useState(false);
  const [timer, setTimer] = useState(0);
  const [text, setText] = useState("");
  const [isActive, setIsActive] = useState(false);
  const [refreshForFullScreen, setRefreshForFullScreen] = useState(false);
  const [showFeedbackIframe, setShowFeedbackIframe] = useState(false);
  const [iframeSRC, setIframeSRC] = useState("");
  const [isIframeClose, setIsIframeClose] = useState(false);
  const [uniboxSingleRefresh, setUniboxSingleRefresh] = useState(false);
  const [messageCounter, setMessageCounter] = useState(0);
  const [sessionIdForClose, setSessionIdForClose] = useState(null);
  const [activeConversation, setActiveConversation] = useState(null);
  const [clientChannel, setClientChannel] = useState(null);
  const [autoLoggedIn, setAutoLoggedIn] = useState(false);
  const [errorMessage, setErrorMessage] = useState(null);
  const isFullScreen = localStorage.getItem("openInFullScreen");
  const [agentInfo, setAgentInfo] = useState(null);
  const [isOffline, setIsOffline] = useState(!!s360ConfigService?.config?.configDetails?.offline);
  let intervalId = 0;
  useEffect(() => {
    console.log(s360ConfigService.config)
    if(!s360ConfigService.config.showLanguageToggle){
      setIsShowLanguageDropdown(false)
    }
  }, []);

  // Recompute closing-hours/holiday (offline) state on an interval so it flips
  // live mid-session instead of relying on the value cached at page load.
  useEffect(() => {
    const syncOffline = () => {
      const previous = !!s360ConfigService?.config?.configDetails?.offline;
      const next = s360ConfigService.recomputeOffline();
      if (next === previous) {
        return;
      }
      setIsOffline(next);
      // Only reroute when the user is not in an active conversation; on the
      // conversation page the input box already disables itself when offline.
      if (next && visiblePage !== PageName.conversationPage) {
        moveToPage(PageName.offlinePage);
      } else if (!next && visiblePage === PageName.offlinePage) {
        moveToPage(PageName.initialForm);
      }
    };
    syncOffline();
    const offlineIntervalId = setInterval(syncOffline, 60000);
    return () => clearInterval(offlineIntervalId);
  }, [visiblePage]);
  useEffect(() => {
    initialize();
    const launchIconHeight = document.getElementById("test-container")?.clientHeight / 10;
    console.log(launchIconHeight)
    document.documentElement.style.setProperty("--launchIcon-height", `${launchIconHeight + 2}rem`);
  }, []);

  useEffect(() => {
    // Silently re-login with saved form data when session is restored from parent
    if (props.restoredFormData && !HWUser.isLoggedIn()) {
      if (s360ConfigService.isConfigured()) {
        login(props.restoredFormData, { silent: true });
      } else {
        // Config not ready yet — store for retry when config arrives
        pendingFormData.current = props.restoredFormData;
      }
    }
  }, [props.restoredFormData]);

  useEffect(() => {
    // Retry silent re-login if form data was pending and config is now ready
    if (pendingFormData.current && !HWUser.isLoggedIn() && s360ConfigService.isConfigured()) {
      login(pendingFormData.current, { silent: true });
      pendingFormData.current = null;
    }
  }, [props.refresh]);

  useEffect(() => {
    if (!isLoggedIn && !!s360ConfigService?.config?.sandBox) {
      checkAndAutoLogin();
    }

  }, [isAppOpen]);

  useEffect(() => {

    if (s360ConfigService?.config?.sandBox) {
      sandBoxLogin()
      setIsAppOpen(s360ConfigService.config.autoPopup);
    }

  }, [s360ConfigService.config]);


  useEffect(() => {

    if (s360ConfigService?.config?.anonymous && !isLoggedIn) {

      if (!s360ConfigService?.config?.configDetails?.showChannels) {

        login()
      }
      if (s360ConfigService?.config?.autoPopup) {
        const delay = s360ConfigService.config?.configDetails?.autoPopupDelay || 0;
        if (delay > 0) {
          setTimeout(() => {
            setIsAppOpen(true);
            sendOnAppOpen();
          }, delay);
        } else {
          setIsAppOpen(true);
          sendOnAppOpen();
        }
      }
    } else if (s360ConfigService?.config?.sandBox) {
      setIsAppOpen(s360ConfigService.config.autoPopup);
      if (s360ConfigService.config.autoPopup) {
        sendOnAppOpen();
      } else {
        sendOnAppClose()
      }
    }
  }, [s360ConfigService.config?.autoPopup]);

  useEffect(() => {

    document.documentElement.style.setProperty("--primary-color", s360ConfigService?.config?.configDetails?.primaryColor);
  }, [s360ConfigService?.config?.configDetails?.primaryColor]);

  useEffect(() => {
    document.documentElement.style.setProperty("--primary-font-color", s360ConfigService?.config?.configDetails?.primaryFontColor);
  }, [s360ConfigService?.config?.configDetails?.primaryFontColor]);

  useEffect(() => {
    document.documentElement.style.setProperty("--font-family", s360ConfigService?.config?.configDetails?.fontFamily);
  }, [s360ConfigService?.config?.configDetails?.fontFamily]);

  const initialize = () => {
    HWLog.info("Is Logged In: " + isLoggedIn);
    setShowForm(s360ConfigService?.config?.configDetails?.showForm);
    let showChannels = s360ConfigService?.config?.configDetails?.showChannels;

    let firstPage = PageName?.initialForm;
    if (!isLoggedIn) {
      //loggedout

      if (s360ConfigService?.config?.anonymous) {
        if (!showChannels)
          firstPage = PageName?.landingPage
      }
      else {
        firstPage = PageName?.initialForm
      }
    }
    else {
      firstPage = PageName?.landingPage
    }

    setVisiblePage(
      s360ConfigService?.config?.configDetails?.offline
        ? "offlinePage"
        : firstPage
    );
    setShowActivityIndicator(isLoggedIn ? false : !(!isLoggedIn && showForm));
    if (s360ConfigService.config.autoFullScreen) {
      localStorage.setItem("openInFullScreen", "true");
      window.parent.postMessage(
        {
          fullScreen: "true",
        },
        "*" //or "www.parentpage.com"
      );
    } else {
      localStorage.removeItem("openInFullScreen");
    }
    if (
      s360ConfigService.config.autoPopup ||
      s360ConfigService.config.hideIcon
    ) {
      const delay = s360ConfigService.config?.configDetails?.autoPopupDelay || 0;
      if (delay > 0) {
        setTimeout(() => onStartUpClick(), delay);
      } else {
        onStartUpClick();
      }
    }
    if (isAppOpen && !isLoggedIn) {
      checkAndAutoLogin();
    }

    if (!isLoggedIn) {
      startTimer();
    }
    if (localStorage.getItem("autoOpenChat")) {
      onStartUpClick();
    }
    if (s360ConfigService.config.disableLocalSession) {
      window.parent.postMessage(
        {
          deleteClientHostId: "true",
        },
        "*" //or "www.parentpage.com"
      );
    }
  };

  // TODO: very brittle code, needs to be refactored
  useEffect(() => {
    if (chatMaximizedTrigger.current) {
      onStartUpClick();
    } else {
      chatMaximizedTrigger.current = true;
    }
  }, [props?.chatMaximized]);

  const handleClose = () => setIsVisible(false);

  const isActiveConversation = () => {
    let isClosed = activeConversation && activeConversation?.active === false;
    return !isClosed;
  };

  const startTimer = () => {
    if (s360ConfigService?.config?.popupMessage?.length > 0) {
      s360ConfigService?.config?.popupMessage.sort(
        (a, b) => getTimeInSec(a.time) - getTimeInSec(b.time)
      );
      intervalId = setInterval(countIncrease, 1000);
      if (s360ConfigService.config?.disableTimerMessages === false) {
        let lap = s360ConfigService?.config?.popupMessage?.at(-1)?.time;
        if (lap !== undefined) {
          if (getTimeInSec(lap) < timer) {
            clearInterval(intervalId);
          }
        }
      }
    }
  };

  const getTimeInSec = (time) => {
    if (time !== undefined) {
      const [hours, minutes, seconds] = time.toString().split(":");
      return +hours * 60 * 60 + +minutes * 60 + +seconds;
    }
  };

  const countIncrease = () => {
    let interval = timer + 1;
    setTimer(interval);
    if (s360ConfigService.config.disableTimerMessages === false) {
      let lap = s360ConfigService.config.popupMessage.at(-1).time;
      if (lap !== undefined) {
        if (isActiveConversation() || getTimeInSec(lap) < timer) {
          clearInterval(intervalId);
          setIsVisible(false);
        }
      }
    }

    let msg = s360ConfigService.config.popupMessage.find(({ time }) => getTimeInSec(time) === interval);

    //for popup effect only
    let check = s360ConfigService.config.popupMessage.find(({ time }) => getTimeInSec(time) === interval + 1);

    if (check) {
      setIsVisible(false);
    }

    //To display message
    if (msg) {
      let text = msg.text;
      setText(text);
      setIsVisible(true);
    }
  };
  const closeAndPostMessage = () => {
    setIsAppOpen(false);
    sendOnAppClose()
  }
  const actions = {
    refreshForFullScreen: () => setRefreshForFullScreen(true),
    startChat: (formDetails) => login(formDetails),
    startConversation: (details, completionHandler) => startConversation(details, completionHandler),
    showLandingScreen: () => moveToPage(PageName.landingPage),
    onStartUpClick: () => onStartUpClick(),
    markActiveConversationAsClosed: () => markActiveConversationAsClosed(),
    onHideChatWindow: () => closeAndPostMessage(),
    showPopUpMessage: (message) => triggerPopupMessage(message),
    submitForm: (contactFormDetails) => submitForm(contactFormDetails),
    closePopup: () => closePopup(),
    setAgentInfo: (data) => setAgentInfo(data)
  };

  const moveToConversationPage = () => {

    forceAutoLogin();
  };

  const forceAutoLogin = () => {
    let configFormDetails = { ...s360ConfigService.s360UserConfig };
    login(configFormDetails);
  };
  const checkAndAutoLogin = () => {
    s360ConfigService.loadClientConfigFromToken();
    if (
      !isLoggedIn &&
      s360ConfigService.config.configDetails?.showForm === false && !s360ConfigService.config.configDetails?.showChannels
      && isAppOpen
    ) {
      let configFormDetails = { ...s360ConfigService.s360UserConfig };
      login(configFormDetails);

    }



  };

  const onStartUpClick = () => {
    
    setIsAppOpen(!isAppOpen);
    resetMessageCounter();
    if (!isAppOpen) {
      if (localStorage.getItem("openInFullScreen")) {
        window.parent.postMessage(
          {
            fullScreen: "true",
          },
          "*" //or "www.parentpage.com"
        );
      }
      if (
        localStorage.getItem("openInFullScreen") === undefined ||
        localStorage.getItem("openInFullScreen") === null
      ) {
        sendOnAppOpen();
      }
    } else {
      sendOnAppClose();
    }

    localStorage.removeItem("finalvalue");

    const isWindows = /windows/i.test(navigator.userAgent);
    const isAndroid = /android/i.test(navigator.userAgent);  
      if (
      (isWindows||isAndroid) &&
      !s360ConfigService?.config?.sandBox &&
      s360ConfigService.config?.configDetails?.browserNotification &&
      Notification.permission !== "granted"
    ) {
      requestNotification();
    } else {
      console.warn("Notifications are not supported on this browser");
    }
  };
  const sandBoxLogin = () => {
    if (s360ConfigService?.config?.sandBox) {
      setShowActivityIndicator(false);
      setClientChannel(null);
      setAutoLoggedIn(true);
      console.log(s360ConfigService?.config?.PageName, "here1234")
      if (s360ConfigService?.config?.PageName === "landingPage") {
        console.log("reached here", "here1234")
        moveToPage(PageName.landingPage)
        return
      }
      else if (s360ConfigService?.config?.configDetails?.offline) {
        moveToPage(PageName.offlinePage)
      }
      else {
        moveToPage(s360ConfigService?.config?.PageName || PageName.conversationPage)
      }
    }

  }

  const login = (formDetails, options = {}) => {
    const { silent = false } = options;
    // always adding User config along with form data
    let configFormDetails = { ...s360ConfigService.s360UserConfig };

    setShowActivityIndicator(true);

    if (s360ConfigService?.config?.sandBox) {
      setShowActivityIndicator(false);
      setClientChannel(null);
      setAutoLoggedIn(true);
      moveToPage(s360ConfigService?.config?.PageName || PageName.conversationPage);
    } else {
      return apiService
        .logInWithFormData({ ...formDetails, ...configFormDetails })
        .then((loginResult) => {
          console.log("LOGIN Result: ", loginResult.data);
          if (!loginResult.data || loginResult.data.error) {
            if (silent) {
              console.warn("Silent re-login failed, showing form.", loginResult.data?.error);
              setShowActivityIndicator(false);
              moveToPage(PageName.initialForm);
            } else {
              setErrorMessage(loginResult.data.error || "");
              triggerPopupMessage(loginResult.data.error || "Something went wrong. Please try again.");
            }
          } else {
            setCometUser(loginResult.data.cometUser);
            setCometToken(loginResult.data.cometToken);
            HWUser.updateUserDetails(loginResult.data);
            saveLoginSessionToParent(formDetails);
            if (s360ConfigService.config.hideChatHis) {
              setAutoLoggedIn(true);
            }
            setShowActivityIndicator(false);
            setClientChannel(loginResult.data);
            if (!localStorage.getItem("isLoggedIn")) {
              moveToPage(PageName.initialForm)
            }
            else {
              moveToPage(PageName.landingPage); // cometD connection is handled on landing screen.
            }
          }
        })
        .catch((onAPIError) => {
          if (silent) {
            console.warn("Silent re-login error, falling back to form.", onAPIError);
            moveToPage(PageName.initialForm);
          } else {
            console.log(onAPIError, "onAPIError");
          }
          setShowActivityIndicator(false);
        });
    }
  };

  const markActiveConversationAsClosed = () => {
    if (activeConversation) {
      let activeConversationTemp = { ...activeConversation };
      activeConversationTemp.active = false;
      setActiveConversation(activeConversationTemp);
    }
  };

  const triggerPopupMessage = (message) => {
    if (!message) {
      return;
    }
    setPopUpMessage(message);
    setShowActivityIndicator(false);
  };

  // Moves to existing conversation.
  const startConversation = (conversationDetials, completionHandler) => {
    const { saveUserMetaData } = CometdActions(cometd);
    setActiveConversation(conversationDetials);
    setIsActive(true);
    clearInterval(intervalId);
    // console.log("COMETD-LOG:SENDING USER META DATA");
    saveUserMetaData(s360ConfigService.userData, conversationDetials.sessionId);
    moveToPage(PageName.conversationPage, completionHandler);
  };

  const moveToPage = (pageName) => {
    console.log("moving to page", pageName)
    setVisiblePage(pageName);
  };

  const onAPIError = (error) => {
    let messageToShow = error && error.message === "Network Error"
      ? "Please check your internet connectivity."
      : "Could not connect to server, please try again.";
    triggerPopupMessage(messageToShow);
  };

  const containerStyle = () => {
    const x = window.matchMedia("(max-width: 400px)");

    return {
      display: !isAppOpen ? "none" : "flex",
      borderRadius:
        x.matches || localStorage.getItem("openInFullScreen") || s360ConfigService?.config?.preview ? "0px" : "10px",

      ...s360ConfigService.config?.customDesign?.mainFloatContainer,
    };
  };

  const submitForm = (contactFormDetails) => {
    return apiService
      .createTicketWithFormData(contactFormDetails)
      .then((result) => {
        HWLog.info("Contact form result: ", result.data);
        if (!result.data || result.data.error) {
          setErrorMessage(result.data.error || "");
          triggerPopupMessage(result.data.error || "Something went worng. Please try again.");
        } else {
          triggerPopupMessage("Form submitted successfully");
        }
      })
      .catch(onAPIError);
  };

  const closePopup = () => {
    setPopUpMessage(null);
  };

  const parseSurveyTriggerResponse = (msg) => {
    console.log("SURVEY TRIGGERED!!!")
    setShowFeedbackIframe(true);
    setIframeSRC(msg?.message?.text);
    setSessionIdForClose(msg?.sessionId);
  };

  const handleCloseIcon = () => {
    setShowFeedbackIframe(false);
    setIsIframeClose(true);
  };

  const resetIframe = () => setIsIframeClose(false);

  const increaseMessageCounter = () => setMessageCounter(messageCounter + 1);

  const resetMessageCounter = () => setMessageCounter(0);

  const state = {
    visiblePage,
    isAppOpen,
    popUpMessage,
    showActivityIndicator,
    isVisible,
    timer,
    text,
    isActive,
    refreshForFullScreen,
    showFeedbackIframe,
    iframeSRC,
    isIframeClose,
    uniboxSingleRefresh,
    messageCounter,
    sessionIdForClose,
    activeConversation,
    clientChannel,
    autoLoggedIn,
    errorMessage,
  };

  return (
    <>
      {messageCounter > 0 && !isAppOpen && (
        <MessageNotification
          counter={messageCounter > 9 ? "9+" : messageCounter}
        />
      )}
      {!s360ConfigService.config.hideIcon && (
        <StartUp actions={actions} />
      )}
      {isAppOpen && (
        <div
          id="container"
          // eslint-disable-next-line max-len
          className={`s360-main-float-container${isFullScreen ? "-fs" : ""}`}
          style={containerStyle()}
        >
          {visiblePage === PageName.offlinePage && (
            <InitialForm
              key={"inital-form-" + false}
              config={s360ConfigService.config}
              actions={actions}
              {...state}
            />
          )}
          {visiblePage === PageName.initialForm && !showActivityIndicator && (
            <InitialForm
              moveToConversationPage={moveToConversationPage}
              key={"inital-form-" + isLoggedIn}
              config={s360ConfigService.config}
              actions={actions}
              {...state}
              errorMessage={popUpMessage}
            />
          )}
          {visiblePage === PageName.landingPage && (
            <LandingPage
              agentInfo={agentInfo}
              uniboxSingleRefreshChange={() => setUniboxSingleRefresh(true)}
              key={"landing-page-" + isLoggedIn}
              config={s360ConfigService.config}
              actions={actions}
              {...state}
              clientChannel={clientChannel}
              {...props}
            />
          )}
          {visiblePage === PageName.conversationPage && (
            <ConversationPage
              agentInfo={agentInfo}
              increaseMessageCounter={increaseMessageCounter}
              uniboxSingleRefresh={uniboxSingleRefresh}
              resetIframe={resetIframe}
              chatStatus={isAppOpen}
              key={"conversation-page-" + isLoggedIn}
              config={s360ConfigService.config}
              conversation={activeConversation}
              actions={actions}
              isOffline={isOffline}
              {...state}
              {...props}
              parseSurveyTriggerResponse={parseSurveyTriggerResponse}
              isIframeClose={isIframeClose}
              sessionIdForClose={sessionIdForClose}
              isShowLanguageDropdown={isShowLanguageDropdown}
              setIsShowLanguageDropdown={setIsShowLanguageDropdown}
              selectedLanguage={selectedLanguage}
              setSelectedLanguage={setSelectedLanguage}
            />
          )}
          {showActivityIndicator && <ActivityIndicator />}
          {popUpMessage && (
            <PopUpMessage
              popUpMessage={popUpMessage}
              onClose={closePopup}
              addTodoItem={props.addTodoItem}
            />
          )}
        </div>
      )}

      {showFeedbackIframe && (
        <IframeContainer src={iframeSRC} handleCloseIcon={handleCloseIcon} />
      )}
      {!isLoggedIn &&
        isVisible &&
        !isAppOpen &&
        s360ConfigService.config.enableTimerMessages && (
        <div
          id="s360-popup-float-message-container-id"
          className="s360-popup-float-message-container s360-hidden"
        >
          <div className="s360-popup-float-img">
            <img
              src={closeImg}
              height="8px"
              alt="closeImg"
              width="8px"
              style={{
                marginBottom: "4px",
                marginLeft: "128px",
                cursor: "pointer",
              }}
              id="s360-popup-float-img-id"
              onClick={handleClose}
            />
          </div>
          <span
            id="s360-popup-float-message-id"
            className="s360-popup-float-message"
          >
            {text}
          </span>
        </div>
      )}
    </>
  );
}

export default Simplify360Chat;
